import { Component, Input, OnInit } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import { AppUrls } from 'projects/bis-shared/src/lib/utility/appurls';
import { map } from 'rxjs/operators';
import { some, isEmpty } from 'lodash';
import { EntityTypeCode } from 'projects/bis-shared/src/lib/utility/system-type-constants';
import { IdentityEntityGroup } from 'projects/bis-shared/src/lib/auth/security-models';
import { Roles } from 'projects/bis-shared/src/lib/utility/roles';

@Component({
  selector: 'app-healthcare-provider-dashboard',
  templateUrl: './healthcare-provider-dashboard.component.html',
  styleUrls: ['./healthcare-provider-dashboard.component.scss'],
})
export class HealthcareProviderDashboardComponent implements OnInit {
  AppUrls = AppUrls;

  selectedTabIndex: number;
  hidePriorAuth: boolean;
  @Input() redirectToTabIndex: number;

  constructor(private identityService: IdentityService) {}

  ngOnInit(): void {
    this.identityService.identity$.pipe(map(identity => identity?.entityGroups)).subscribe(eg => {
      this.hidePriorAuth = !some(eg, (g: IdentityEntityGroup) => (
        g.entityTypeCode === EntityTypeCode.HealthcareProvider &&
          some(g.userRoleCodes, (r: Roles) => !isEmpty(r) && r !== Roles.HPBillingDelegate)
      ));

      if (this.hidePriorAuth && !this.selectedTabIndex) {
        this.selectedTabIndex = 1;
      }
    });
  }
}
